webpackJsonp([263791100135453],{

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.AboutPageContent = undefined;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _constants = __webpack_require__(4);
	
	var _Common = __webpack_require__(18);
	
	var _AspectRatioImage = __webpack_require__(28);
	
	var _AspectRatioImage2 = _interopRequireDefault(_AspectRatioImage);
	
	var _QuienesSomos = __webpack_require__(108);
	
	var _QuienesSomos2 = _interopRequireDefault(_QuienesSomos);
	
	var _Equipo = __webpack_require__(107);
	
	var _Equipo2 = _interopRequireDefault(_Equipo);
	
	var _Colaboradores = __webpack_require__(106);
	
	var _Colaboradores2 = _interopRequireDefault(_Colaboradores);
	
	var _Visitanos = __webpack_require__(109);
	
	var _Visitanos2 = _interopRequireDefault(_Visitanos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var AboutPageContainer = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'eljw2j0'
	})('background-color:white;z-index:95;height:100vh;position:fixed;top:0;width:100%;padding-left:480px;transition:transform 0.5s;transform:translate(-100%,0);display:none;@media screen and (min-width:', _constants.screenWidths.lg, 'px){display:block;}', function (props) {
	  return props.isOpen && '\n    transform: translate(0, 0);\n  ';
	});
	
	var ContentWrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'eljw2j1'
	})(_Common.grid.right, ' padding:20px 20px;');
	
	var Content = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'eljw2j2'
	})('overflow:scroll;height:98vh;padding:10px 100px 0 0;&::-webkit-scrollbar{width:5px;}&::-webkit-scrollbar-thumb{background-color:#818578;}@media screen and (min-width:', _constants.screenWidths.lg, 'px){display:block;}');
	
	var AboutPageContent = exports.AboutPageContent = function AboutPageContent(_ref) {
	  var aboutInfo = _ref.aboutInfo;
	  return React.createElement(
	    'div',
	    null,
	    React.createElement(_QuienesSomos2.default, {
	      title: aboutInfo.pageTitle,
	      mainImage: aboutInfo.mainImage.file.url,
	      description: aboutInfo.description.description
	    }),
	    React.createElement(_Equipo2.default, {
	      title: aboutInfo.teamSectionTitle,
	      team: aboutInfo.team
	    }),
	    React.createElement(_Colaboradores2.default, {
	      title: aboutInfo.colaboradorTitle,
	      colaboradores: aboutInfo.colaboradores
	    }),
	    React.createElement(_Visitanos2.default, {
	      title: aboutInfo.contactSectionTitle,
	      address: aboutInfo.address,
	      email: aboutInfo.contactEmail,
	      number: aboutInfo.phoneNumber
	
	    }),
	    aboutInfo.teamPhoto && React.createElement('img', { className: "imgteam", src: aboutInfo.teamPhoto.file.url })
	  );
	};
	
	var AboutPage = function AboutPage(_ref2) {
	  var isOpen = _ref2.isOpen,
	      aboutInfo = _ref2.aboutInfo,
	      setAboutPageRef = _ref2.setAboutPageRef;
	
	  return React.createElement(
	    AboutPageContainer,
	    { isOpen: isOpen },
	    React.createElement(
	      ContentWrapper,
	      null,
	      React.createElement(
	        Content,
	        { innerRef: setAboutPageRef },
	        React.createElement(AboutPageContent, { aboutInfo: aboutInfo })
	      )
	    )
	  );
	};
	
	exports.default = AboutPage;

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Title = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Info = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'evbakqp0'
	})('width:100%;');
	
	var Title = /*#__PURE__*/exports.Title = (0, _reactEmotion2.default)('h2', {
	  target: 'evbakqp1'
	})('font-family:ZeitungMicroPro-Light;font-weight:normal;margin-bottom:55px;font-size:50px;color:#424149;@media screen and (min-width:', _constants.screenWidths.lg, 'px){text-align:left;}@media screen and (min-width:320px){font-size:45px !important;}');
	
	var ColaboradoresContainer = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'evbakqp2'
	})('width:100%;justify-content:center;flex-wrap:wrap;overflow-x:hidden;display:grid;grid-column-gap:40px;@media screen and (min-width:', _constants.screenWidths.lg, 'px){grid-template-columns:repeat(4,.5fr);}');
	var ColaboradoresContainerAlt = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'evbakqp3'
	})('width:100%;justify-content:center;flex-wrap:wrap;overflow-x:hidden;display:block;grid-column-gap:40px;@media screen and (min-width:', _constants.screenWidths.lg, 'px){}');
	
	var MemberContainer = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'evbakqp4'
	})('text-align:center;width:100%;.imgColaborador{width:312.85px;height:312.85px;min-width:312.85px;object-fit:cover;}p{margin:0px 0px 20px 0px;font-family:ZeitungMicroPro-Light;span{font-family:ZeitungMicroPro-Bold;}}@media screen and (min-width:', _constants.screenWidths.lg, 'px){.imgColaborador{width:150px;height:150px;min-width:150px;}}');
	var MemberContainerAlt = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'evbakqp5'
	})('text-align:center;margin:2% !important;width:21% !important;margin-left:25.5% !important;@media screen and (max-width:574px){width:100% !important;margin:0 !important;}@media screen and (min-width:1800px){margin-left:-22% !important;}float:left;.imgColaborador{width:312.85px;height:312.85px;min-width:312.85px;object-fit:cover;}p{margin:0px 0px 20px 0px;font-family:ZeitungMicroPro-Light;span{font-family:ZeitungMicroPro-Bold;}}@media screen and (min-width:', _constants.screenWidths.lg, 'px){.imgColaborador{width:150px;height:150px;min-width:150px;}}');
	var MemberContainerAltLeft = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'evbakqp6'
	})('text-align:center;margin:2% !important;width:21% !important;float:left;@media screen and (max-width:575px){width:100% !important;margin:0 !important;margin-left:0 !important;}float:left;.imgColaborador{width:312.85px;height:312.85px;min-width:312.85px;object-fit:cover;}p{margin:0px 0px 20px 0px;font-family:ZeitungMicroPro-Light;span{font-family:ZeitungMicroPro-Bold;}}@media screen and (min-width:', _constants.screenWidths.lg, 'px){.imgColaborador{width:150px;height:150px;min-width:150px;}}');
	
	var ColaboratorMember = function ColaboratorMember(_ref) {
	  var colaboradorJob = _ref.colaboradorJob,
	      colaboradorName = _ref.colaboradorName,
	      fotoColaborador = _ref.fotoColaborador;
	
	  return _react2.default.createElement(
	    MemberContainer,
	    null,
	    _react2.default.createElement('img', { className: "imgColaborador", src: fotoColaborador.file.url }),
	    _react2.default.createElement(
	      'p',
	      null,
	      colaboradorName,
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'span',
	        null,
	        colaboradorJob
	      )
	    )
	  );
	};
	var ColaboratorMemberRight = function ColaboratorMemberRight(_ref2) {
	  var colaboradorJob = _ref2.colaboradorJob,
	      colaboradorName = _ref2.colaboradorName,
	      fotoColaborador = _ref2.fotoColaborador;
	
	  return _react2.default.createElement(
	    MemberContainer,
	    { dir: "right" },
	    _react2.default.createElement('img', { className: "imgColaborador", src: fotoColaborador.file.url }),
	    _react2.default.createElement(
	      'p',
	      null,
	      colaboradorName,
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'span',
	        null,
	        colaboradorJob
	      )
	    )
	  );
	};
	var ColaboratorMemberLeft = function ColaboratorMemberLeft(_ref3) {
	  var colaboradorJob = _ref3.colaboradorJob,
	      colaboradorName = _ref3.colaboradorName,
	      fotoColaborador = _ref3.fotoColaborador;
	
	  return _react2.default.createElement(
	    MemberContainer,
	    { dir: "left" },
	    _react2.default.createElement('img', { className: "imgColaborador", src: fotoColaborador.file.url }),
	    _react2.default.createElement(
	      'p',
	      null,
	      colaboradorName,
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'span',
	        null,
	        colaboradorJob
	      )
	    )
	  );
	};
	var ColaboratorMemberAlt = function ColaboratorMemberAlt(_ref4) {
	  var colaboradorJob = _ref4.colaboradorJob,
	      colaboradorName = _ref4.colaboradorName,
	      fotoColaborador = _ref4.fotoColaborador;
	
	  return _react2.default.createElement(
	    MemberContainerAlt,
	    null,
	    _react2.default.createElement('img', { className: "imgColaborador", src: fotoColaborador.file.url }),
	    _react2.default.createElement(
	      'p',
	      null,
	      colaboradorName,
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'span',
	        null,
	        colaboradorJob
	      )
	    )
	  );
	};
	var ColaboratorMemberAltLeft = function ColaboratorMemberAltLeft(_ref5) {
	  var colaboradorJob = _ref5.colaboradorJob,
	      colaboradorName = _ref5.colaboradorName,
	      fotoColaborador = _ref5.fotoColaborador;
	
	  return _react2.default.createElement(
	    MemberContainerAltLeft,
	    null,
	    _react2.default.createElement('img', { className: "imgColaborador", src: fotoColaborador.file.url }),
	    _react2.default.createElement(
	      'p',
	      null,
	      colaboradorName,
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'span',
	        null,
	        colaboradorJob
	      )
	    )
	  );
	};
	
	var Colaboradores = function (_Component) {
	  _inherits(Colaboradores, _Component);
	
	  function Colaboradores() {
	    _classCallCheck(this, Colaboradores);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Colaboradores.prototype.render = function render() {
	    return _react2.default.createElement(
	      Info,
	      null,
	      _react2.default.createElement(
	        Title,
	        null,
	        this.props.title
	      ),
	      this.props.colaboradores && this.props.colaboradores.length % 4 == 0 && _react2.default.createElement(
	        ColaboradoresContainer,
	        null,
	        this.props.colaboradores && this.props.colaboradores.map(function (c, idx) {
	          return _react2.default.createElement(ColaboratorMember, c);
	        })
	      ),
	      this.props.colaboradores && this.props.colaboradores.length % 4 !== 0 && _react2.default.createElement(
	        ColaboradoresContainerAlt,
	        null,
	        this.props.colaboradores && this.props.colaboradores.map(function (c, idx) {
	          return idx != 4 ? _react2.default.createElement(ColaboratorMemberAltLeft, c) : idx != 0 ? _react2.default.createElement(ColaboratorMemberAlt, c) : console.log(idx);
	        })
	      )
	    );
	  };
	
	  return Colaboradores;
	}(_react.Component);
	
	exports.default = Colaboradores;

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Title = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Info = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'en1sk5i0'
	})('width:100%;');
	
	var Title = /*#__PURE__*/exports.Title = (0, _reactEmotion2.default)('h2', {
	  target: 'en1sk5i1'
	})('font-family:ZeitungMicroPro-Light;font-weight:normal;margin-bottom:55px;font-size:50px;color:#424149;@media screen and (min-width:', _constants.screenWidths.lg, 'px){text-align:left;}');
	
	var LiderContainer = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'en1sk5i2'
	})('width:100%;text-align:center;display:flex;justify-content:center');
	
	var LiderMemberContainer = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'en1sk5i3'
	})('text-align:center;width:500px;.imgLider{width:500px;height:312.85px;min-width:312.85px;object-fit:cover;}p{margin:0px 0px 20px 0px;font-family:ZeitungMicroPro-Light;span{font-family:ZeitungMicroPro-Bold;}}');
	
	var TeamContainer = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'en1sk5i4'
	})('display:grid;grid-column-gap:40px;width:100%;@media screen and (min-width:', _constants.screenWidths.lg, 'px){grid-template-columns:repeat(3,.5fr);}');
	
	var TeamMemberContainer = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'en1sk5i5'
	})('text-align:center;.imgTeam{width:312.85px;height:312.85px;margin-top:40px;object-fit:cover;}p{margin:0px 0px 20px 0px;font-family:ZeitungMicroPro-Light;span{font-family:ZeitungMicroPro-Bold;}}');
	
	var TeamContainerAlt = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'en1sk5i6'
	})('display:block;justify-content:center;align-items:center;width:100%;overflow:hidden;@media screen and (min-width:', _constants.screenWidths.lg, 'px){}');
	
	var TeamMemberContainerAlt = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'en1sk5i7'
	})('text-align:center;width:29%;margin:2% !important;float:left;margin:0 auto;margin-left:16vw !important;@media screen and (max-width:575px){width:100% !important;margin:0 !important;margin-left:0 !important;}@media screen and (min-width:1564px){margin-left:-10vw !important;}@media screen and (min-width:1576px){margin-left:10vw !important;}@media screen and (min-width:1718px){margin-left:10vw !important;}@media screen and (min-width:1736px){margin-left:10vw !important;}@media screen and (min-width:1740px){margin-left:10vw !important;}@media screen and (min-width:1800px){margin-left:-10vw !important;}@media screen and (min-width:1920px){margin-left:10vw !important;}.imgTeam{width:312.85px;height:312.85px;margin-top:40px;object-fit:cover;}p{margin:0px 0px 20px 0px;font-family:ZeitungMicroPro-Light;span{font-family:ZeitungMicroPro-Bold;}}');
	
	var TeamMemberContainerAltLeft = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'en1sk5i8'
	})('text-align:center;width:29%;margin:2% !important;float:left;margin:0 auto;@media screen and (max-width:575px){width:100% !important;margin:0 !important;margin-left:0 !important;}.imgTeam{width:312.85px;height:312.85px;margin-top:40px;object-fit:cover;}p{margin:0px 0px 20px 0px;font-family:ZeitungMicroPro-Light;span{font-family:ZeitungMicroPro-Bold;}}');
	
	var LiderMember = function LiderMember(_ref) {
	  var picture = _ref.picture,
	      fullName = _ref.fullName,
	      jobTitle = _ref.jobTitle,
	      description = _ref.description,
	      id = _ref.id;
	
	  return _react2.default.createElement(
	    LiderMemberContainer,
	    null,
	    _react2.default.createElement('img', { className: "imgLider", src: picture.file.url }),
	    _react2.default.createElement(
	      'p',
	      null,
	      fullName,
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'span',
	        null,
	        jobTitle
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      description.description
	    )
	  );
	};
	
	var TeamMember = function TeamMember(_ref2) {
	  var picture = _ref2.picture,
	      fullName = _ref2.fullName,
	      jobTitle = _ref2.jobTitle,
	      description = _ref2.description,
	      id = _ref2.id;
	
	  return _react2.default.createElement(
	    TeamMemberContainer,
	    null,
	    _react2.default.createElement('img', { className: "imgTeam", src: picture.file.url }),
	    _react2.default.createElement(
	      'p',
	      null,
	      fullName,
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'span',
	        null,
	        jobTitle
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      description.description
	    )
	  );
	};
	
	var TeamMemberAlt = function TeamMemberAlt(_ref3) {
	  var picture = _ref3.picture,
	      fullName = _ref3.fullName,
	      jobTitle = _ref3.jobTitle,
	      description = _ref3.description,
	      id = _ref3.id;
	
	  return _react2.default.createElement(
	    TeamMemberContainerAlt,
	    null,
	    _react2.default.createElement('img', { className: "imgTeam", src: picture.file.url }),
	    _react2.default.createElement(
	      'p',
	      null,
	      fullName,
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'span',
	        null,
	        jobTitle
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      description.description
	    )
	  );
	};
	
	var TeamMemberAltLeft = function TeamMemberAltLeft(_ref4) {
	  var picture = _ref4.picture,
	      fullName = _ref4.fullName,
	      jobTitle = _ref4.jobTitle,
	      description = _ref4.description,
	      id = _ref4.id;
	
	  return _react2.default.createElement(
	    TeamMemberContainerAltLeft,
	    null,
	    _react2.default.createElement('img', { className: "imgTeam", src: picture.file.url }),
	    _react2.default.createElement(
	      'p',
	      null,
	      fullName,
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'span',
	        null,
	        jobTitle
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      description.description
	    )
	  );
	};
	
	var Equipo = function (_Component) {
	  _inherits(Equipo, _Component);
	
	  function Equipo() {
	    _classCallCheck(this, Equipo);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Equipo.prototype.render = function render() {
	    return _react2.default.createElement(
	      Info,
	      null,
	      _react2.default.createElement(
	        Title,
	        null,
	        this.props.title
	      ),
	      _react2.default.createElement(
	        LiderContainer,
	        null,
	        this.props.team.map(function (t, idx) {
	          return idx == 0 && _react2.default.createElement(LiderMember, _extends({ key: t.id }, t));
	        })
	      ),
	      (this.props.team.length - 1) % 3 == 0 && _react2.default.createElement(
	        TeamContainer,
	        null,
	        this.props.team.map(function (t, idx) {
	          return idx != 0 && _react2.default.createElement(TeamMember, _extends({ key: t.id }, t));
	        })
	      ),
	      (this.props.team.length - 1) % 3 !== 0 && _react2.default.createElement(
	        TeamContainerAlt,
	        null,
	        this.props.team.map(function (t, idx) {
	          return idx != 0 && idx != 4 ? _react2.default.createElement(TeamMemberAltLeft, _extends({ key: t.id }, t)) : idx != 0 ? _react2.default.createElement(TeamMemberAlt, _extends({ key: t.id }, t)) : console.log(idx);
	        })
	      )
	    );
	  };
	
	  return Equipo;
	}(_react.Component);
	
	exports.default = Equipo;

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Title = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Info = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	    target: 'e9woqir0'
	})('width:100%;.imgNosotros{width:100%;height:480px;object-fit:cover;}p.text{font-family:ZeitungMicroPro-Light;line-height:2em;margin-bottom:2em;text-align:justify;}');
	
	var Title = /*#__PURE__*/exports.Title = (0, _reactEmotion2.default)('h2', {
	    target: 'e9woqir1'
	})('font-family:ZeitungMicroPro-Light;font-weight:normal;margin-bottom:55px;font-size:50px;color:#424149;@media screen and (min-width:', _constants.screenWidths.lg, 'px){text-align:left;}');
	
	var QuienesSomos = function (_Component) {
	    _inherits(QuienesSomos, _Component);
	
	    function QuienesSomos() {
	        _classCallCheck(this, QuienesSomos);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    QuienesSomos.prototype.render = function render() {
	        return _react2.default.createElement(
	            Info,
	            null,
	            _react2.default.createElement(
	                Title,
	                null,
	                this.props.title
	            ),
	            _react2.default.createElement('img', { className: "imgNosotros", src: this.props.mainImage }),
	            this.props.description.split('\n').map(function (t, i) {
	                return _react2.default.createElement(
	                    'p',
	                    { key: i, className: 'text' },
	                    t
	                );
	            })
	        );
	    };
	
	    return QuienesSomos;
	}(_react.Component);
	
	exports.default = QuienesSomos;

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Title = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Info = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	    target: 'exetbt80'
	})('width:100%;.email{font-family:ZeitungMicroPro-Light;font-size:20px;}.number{font-family:ZeitungMicroPro-Light;font-size:20px;}.address{font-family:ZeitungMicroPro-Light;font-size:14px;}');
	
	var Title = /*#__PURE__*/exports.Title = (0, _reactEmotion2.default)('h2', {
	    target: 'exetbt81'
	})('font-family:ZeitungMicroPro-Light;font-weight:normal;margin-bottom:55px;font-size:50px;color:#424149;@media screen and (min-width:', _constants.screenWidths.lg, 'px){text-align:left;}');
	
	var Visitanos = function (_Component) {
	    _inherits(Visitanos, _Component);
	
	    function Visitanos() {
	        _classCallCheck(this, Visitanos);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Visitanos.prototype.render = function render() {
	        return _react2.default.createElement(
	            Info,
	            null,
	            _react2.default.createElement(
	                Title,
	                null,
	                this.props.title
	            ),
	            _react2.default.createElement('iframe', {
	                src: 'https://snazzymaps.com/embed/130783',
	                width: '100%',
	                height: '357',
	                frameBorder: '0',
	                style: { border: 0 },
	                allowFullScreen: true
	            }),
	            _react2.default.createElement(
	                'p',
	                { className: 'address' },
	                this.props.address
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'email' },
	                this.props.email
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'number' },
	                this.props.number
	            )
	        );
	    };
	
	    return Visitanos;
	}(_react.Component);
	
	exports.default = Visitanos;

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.AspectRatioImgContainer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AspectRatioImgContainer = /*#__PURE__*/exports.AspectRatioImgContainer = (0, _reactEmotion2.default)('div', {
	  target: 'eoyrt8z0'
	})('position:relative;&:before{display:block;content:"";width:100%;padding-top:calc(', function (props) {
	  return props.ratio;
	}, ' * 100%);}> .inner{position:absolute;top:0;right:0;bottom:0;left:0;}img{width:80%;height:80%;margin-left:10%;margin-top:8%;object-fit:contain;}');
	var AspectRatioImage = function AspectRatioImage(_ref) {
	  var _ref$ratio = _ref.ratio,
	      ratio = _ref$ratio === undefined ? 1 : _ref$ratio,
	      src = _ref.src,
	      className = _ref.className,
	      style = _ref.style;
	
	  return _react2.default.createElement(
	    AspectRatioImgContainer,
	    { ratio: ratio, className: className, style: style },
	    _react2.default.createElement(
	      'div',
	      { className: 'inner' },
	      _react2.default.createElement('img', { src: src })
	    )
	  );
	};
	
	exports.default = AspectRatioImage;

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.buttonWrapperStyle = exports.grid = exports.blueScrollbar = exports.LightTitle = exports.TitleMovil = exports.Title = undefined;
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = /*#__PURE__*/exports.Title = (0, _reactEmotion2.default)('h1', {
	  target: 'e1pqqb5p0'
	})('font-family:ZeitungMicroPro-Bold;text-align:center;@media screen and (min-width:', _constants.screenWidths.lg, 'px){font-size:30px;text-align:left;margin-bottom:40px;}');
	
	var TitleMovil = /*#__PURE__*/exports.TitleMovil = (0, _reactEmotion2.default)('h1', {
	  target: 'e1pqqb5p1'
	})('font-family:ZeitungMicroPro-Bold;text-align:center;margin:30px 0 30px;@media screen and (min-width:', _constants.screenWidths.lg, 'px){display:none;font-size:2.5em;text-align:left;margin-bottom:40px;}');
	
	var LightTitle = /*#__PURE__*/exports.LightTitle = (0, _reactEmotion2.default)('h2', {
	  target: 'e1pqqb5p2'
	})('font-family:ZeitungMicroPro-Light;font-weight:normal;margin-bottom:35px;font-size:3em;@media screen and (min-width:', _constants.screenWidths.lg, 'px){font-size:3.5em;text-align:left;}');
	
	var blueScrollbar = exports.blueScrollbar = '\n  overflow: scroll;\n  &::-webkit-scrollbar {\n    width: 5px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--colors-image-border);\n  }\n\n  @media screen and (min-width: ' + _constants.screenWidths.lg + 'px) {\n    display: block;\n  }\n';
	
	var gridTwelveColContainerStyle = '\n  width: 100%;\n  @media screen and (min-width: ' + _constants.screenWidths.lg + 'px) {\n    display: grid;\n    grid-template-columns: repeat(5, minmax(80px, 1fr)) repeat(7, 1fr);\n    grid-column-gap: 10px;\n    grid-row-gap: 50px;\n    grid-auto-flow: dense;\n  }\n';
	
	var gridSidebarStyle = '\n  grid-column: 1 / -1;\n  @media screen and (min-width: ' + _constants.screenWidths.lg + 'px) {\n    grid-column: 1 / 5;\n  }\n';
	
	var gridContentStyle = '\n  grid-column: 1 / -1;\n  @media screen and (min-width: ' + _constants.screenWidths.lg + 'px) {\n    grid-column: 5 / -1;\n  }\n';
	
	var grid = exports.grid = {
	  container: gridTwelveColContainerStyle,
	  left: gridSidebarStyle,
	  right: gridContentStyle
	};
	
	var buttonWrapperStyle = exports.buttonWrapperStyle = '\n  padding: 0;\n  margin: 0;\n  border: none;\n  width: 100%;\n  background: none;\n  outline:none;\n';
	
	// export const onlyLgScreens = css`
	//   display: none;
	//   @media screen and (min-width: ${screenWidths.lg}px) {
	//     display: block;
	//   }
	// `;

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _constants = __webpack_require__(4);
	
	var _AboutPage = __webpack_require__(105);
	
	var _Common = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPageContainer = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'eeh46vk0'
	})('background-color:white;padding:10vh 0;height:100vh;@media screen and (min-width:', _constants.screenWidths.lg, 'px){padding:10vh 0;}', _Common.LightTitle, ':not(:first-child){margin-top:5.5rem;}', _Common.grid.container, ' p.text{font-family:ZeitungMicroPro-Light;line-height:2em;margin-bottom:2em;text-align:justify;}p.bigger{font-family:ZeitungMicroPro-Light;font-size:18px;margin:0;}p.address{font-size:14px;}');
	
	var Content = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'eeh46vk1'
	})('overflow:scroll;&::-webkit-scrollbar{width:5px;}&::-webkit-scrollbar-thumb{background-color:#818578;}@media screen and (min-width:', _constants.screenWidths.lg, 'px){display:block;}grid-column:1 / -1;padding:0 5vw;height:86vh;@media screen and (min-width:', _constants.screenWidths.lg, 'px){height:80vh;grid-column:3 / 11;}.imgNosotros{width:100%;height:300px;object-fit:cover;}');
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    AboutPageContainer,
	    null,
	    _react2.default.createElement(
	      Content,
	      null,
	      _react2.default.createElement(_AboutPage.AboutPageContent, { aboutInfo: data.aboutInfo.edges[0].node })
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-1d7a6bfb30dc89b2cf3e.js